/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: NumericInputComponent,
      multi: true,
    },
  ],
})
export class NumericInputComponent implements ControlValueAccessor {
  @Input() disabled = false; // for accessibility purposes, marks the field as disabled or not

  @Input() required = false; // for accessibility purposes, marks the field as required or not

  // Function to call when the value changes.
  onChange = (value: number) => {};

  // Function to call when the input is touched.
  onTouched = () => {};

  numberString; // bind input to ngmodel

  @Input() stepping = 1; // for accessing different values.

  @Output() ionChange = new EventEmitter();

  @Output() ionInput = new EventEmitter();

  // get accessor
  get number(): any {
    return this.numberString;
  }

  // set accessor including call the onchange callback
  // reference link https://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel
  set number(val: any) {
    if (val !== this.numberString) {
      this.numberString = val;
      this.onChange(val);
      this.onTouched();
    }
  }

  /**
   * Write value function of control value accessor.
   *
   * @param value - This is set value for write value.
   */
  writeValue(value): void {
    if (value !== this.numberString) {
      this.number = value;
    }
    this.ionChange.emit({ detail: { value } });
    this.ionInput.emit({ detail: { value } });
  }

  /**
   * Register on change event for bind value on parent.
   *
   * @param fn - Bind function to onchange function.
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Register On Touche event.
   *
   * @param fn - Bind function to on touch function.
   */
  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  /**
   * This function is used to reduce and increase the number value.
   *
   * @param operator - Set new value for duration as per operator.
   */
  setValue(operator) {
    let number = this.number ? this.number : 0;
    if (operator === 'up') {
      number += this.stepping;
    } else {
      number -= this.stepping;
    }

    this.writeValue(number);
  }

  /**
   * Allows Angular to disable the input.
   *
   * @param isDisabled - To check is current state is disabled or not.
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
